import axios, { hashRequest } from './axios'

export const getSleepSignalsWeighting = (type) =>
    axios.get(`/hsd_weighting/`, { params: { type } })

export const updateSleepSignalsWeighting = (data) =>
    axios.put(`/hsd_weighting/`, data)